import React from 'react';

const CalendarCheckFill: React.FC<React.PropsWithChildren> = () => (
  <path d="M9 1V3H15V1H17V3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9ZM20 8H4V19H20V8ZM15.036 10.136L16.45 11.55L11.5 16.5L7.964 12.964L9.38 11.55L11.501 13.672L15.037 10.136H15.036Z" />
);

export default CalendarCheckFill;
